import { initShopeepayReporter } from '@shopeepay/reporter'

const KNOWN_ROUTES = [
  '/',
  '/contact-us',
  '/download',
  '/feature',
  '/merchant',
  '/register',
]

// shopeepay-ph has no HTTP client (static site, no axios/fetch usage),
// so the axios instrumentation step is omitted.
initShopeepayReporter({
  region: 'ph',
  project: 'shopeepay-ph',
  knownRoutes: KNOWN_ROUTES,
})
